// Shared config for the public institutional site (Guia de Jampa AI)

export const SITE_URL = "https://guiadejampa.com";

// Contact — fill real values to enable the buttons (empty = hidden, avoids fake links)
export const CONTACT = {
  email: "contato@guiadejampa.com",
  whatsapp: "", // ex: "5583999999999" (com DDI+DDD) para habilitar botão WhatsApp
  instagram: "", // ex: "https://instagram.com/guiadejampa"
  facebook: "",
};

// Licensed images (Unsplash / Pexels) — João Pessoa & tema litoral/gastronomia
// Widths downsized based on real display sizes reported by PageSpeed:
// hero (mobile LCP) ≈ 640px wide × 2 DPR → 1280 max; cards ≤ 320px → 640; band ≈ 800.
const U = (id, w = 640) =>
  `https://images.unsplash.com/photo-${id}?auto=format&cs=srgb&fm=jpg&q=70&w=${w}`;

export const IMAGES = {
  // LCP: hero background of the landing. Serve responsive sizes via <img srcset>.
  hero: U("1515898698999-18f625d67499", 1280),
  heroSm: U("1515898698999-18f625d67499", 640),
  heroMd: U("1515898698999-18f625d67499", 960),
  heroLg: U("1515898698999-18f625d67499", 1280),
  heroXl: U("1515898698999-18f625d67499", 1600),
  city: U("1515898034510-821b204966e4", 640),
  beach: U("1561571994-3c61c554181a", 640),
  sunset: U("1460627390041-532a28402358", 1280),
  turismo: U("1571043281665-9debfed10719", 640),
  food: U("1595579547936-c3a0e6c171fc", 640),
  hotel: U("1582719508461-905c673771fd", 640),
  event: U("1533174072545-7a4b6ad7a6c3", 640),
  storefront:
    "https://images.pexels.com/photos/27990876/pexels-photo-27990876.jpeg?auto=compress&cs=tinysrgb&w=800",
};

// Category cards. appHref points to REAL existing app routes.
export const CATEGORIES = [
  { key: "onde-comer", label: "Restaurantes", icon: "Utensils", image: IMAGES.food, href: "/empresas?category=onde-comer", blurb: "Onde comer os melhores pratos da cidade." },
  { key: "hoteis", label: "Hotéis", icon: "Hotel", image: IMAGES.hotel, href: "/empresas?category=hoteis", blurb: "Hospedagem à beira-mar e na cidade." },
  { key: "praias", label: "Praias", icon: "Waves", image: IMAGES.beach, href: "/feed?category=praias", blurb: "Tambaú, Cabo Branco, Bessa e mais." },
  { key: "turismo", label: "Turismo", icon: "Compass", image: IMAGES.turismo, href: "/feed?category=turismo", blurb: "Passeios, pontos turísticos e roteiros." },
  { key: "eventos", label: "Eventos", icon: "CalendarDays", image: IMAGES.event, href: "/feed?category=eventos", blurb: "Shows, festivais e agenda cultural." },
  { key: "promocoes", label: "Promoções", icon: "Tag", image: IMAGES.city, href: "/feed?category=promocoes", blurb: "Ofertas e descontos perto de você." },
  { key: "saude", label: "Saúde", icon: "HeartPulse", image: IMAGES.storefront, href: "/empresas?category=saude", blurb: "Clínicas, hospitais e bem-estar." },
  { key: "imoveis", label: "Imóveis", icon: "Building2", image: IMAGES.city, href: "/empresas?category=imoveis", blurb: "Apartamentos e imóveis na cidade." },
  { key: "empregos", label: "Empregos", icon: "Briefcase", image: IMAGES.storefront, href: "/feed?category=empregos", blurb: "Vagas e oportunidades em João Pessoa." },
  { key: "empresas", label: "Empresas", icon: "Store", image: IMAGES.city, href: "/empresas?category=empresas", blurb: "Negócios e serviços locais." },
];

export const SEARCH_CATEGORIES = CATEGORIES.map((c) => ({ key: c.key, label: c.label }));

// Institutional plan cards (checkout is handled by the existing app /planos + Mercado Pago)
export const SITE_PLANS = [
  { key: "free", name: "Free", price: "R$ 0", period: "", highlight: false,
    features: ["Acesso ao feed", "Mapa interativo", "Favoritos", "3 perguntas grátis à IA", "Perfil básico"],
    cta: "Começar grátis", href: "/cadastro" },
  { key: "business", name: "Business", price: "R$ 49,90", period: "/mês", highlight: false,
    features: ["Página empresarial", "WhatsApp, Instagram e site", "Endereço e fotos", "Promoções", "Dashboard básico", "SEO local"],
    cta: "Assinar Business", href: "/planos" },
  { key: "pro", name: "Pro", price: "R$ 149,90", period: "/mês", highlight: true, badge: "Mais popular",
    features: ["Tudo do Business", "Mais destaque nas listagens", "Insights de IA", "Analytics", "Cupons digitais", "Recomendações"],
    cta: "Assinar Pro", href: "/planos" },
  { key: "premium", name: "Premium", price: "R$ 399,90", period: "/mês", highlight: false, badge: "Mais completo",
    features: ["Tudo do Pro", "Máximo destaque", "Página premium", "Relatórios avançados", "Recursos exclusivos", "Suporte prioritário"],
    cta: "Assinar Premium", href: "/planos" },
  { key: "enterprise", name: "Enterprise", price: "Sob consulta", period: "", highlight: false,
    features: ["Redes e franquias", "Múltiplas unidades", "Integrações", "Relatórios personalizados", "Atendimento dedicado"],
    cta: "Falar com especialista", href: "/contato" },
];

// Planos verticais dedicados — imóveis, médicos e automóveis
// Limites e preços sincronizados com PLANS no backend/server.py
export const VERTICAL_PLANS = [
  { key: "imoveis_pro", name: "Guia Imóveis", vertical: "imoveis",
    price: "R$ 149,90", period: "/mês", accent: "from-emerald-500 to-teal-600",
    icon: "Building2", tag: "Corretores e imobiliárias",
    features: [
      "Perfil de corretor/imobiliária",
      "Até 3 anúncios de imóveis por mês",
      "Venda, aluguel, temporada e lançamentos",
      "Filtros por bairro, tipo, quartos e área",
      "3 impulsionamentos grátis por ciclo",
      "WhatsApp direto no anúncio + SEO local",
    ],
    cta: "Assinar Guia Imóveis", href: "/planos" },
  { key: "medicos_pro", name: "Guia Médicos", vertical: "medicos",
    price: "R$ 399,00", period: "/mês", accent: "from-rose-500 to-red-600",
    icon: "HeartPulse", tag: "Clínicas, médicos e profissionais de saúde",
    features: [
      "Perfil médico verificado com CRM",
      "Até 10 publicações por mês",
      "Consultas, exames, campanhas e artigos",
      "Especialidades, convênios e teleconsulta",
      "3 impulsionamentos grátis por ciclo",
      "Agendamento via WhatsApp com 1 clique",
    ],
    cta: "Assinar Guia Médicos", href: "/planos" },
  { key: "auto_pro", name: "Guia Auto", vertical: "auto",
    price: "R$ 199,90", period: "/mês", accent: "from-sky-500 to-indigo-600",
    icon: "Car", tag: "Concessionárias e revendas",
    features: [
      "Perfil da loja com todas as marcas",
      "Até 10 veículos anunciados por mês",
      "Novos, seminovos e usados (carros e motos)",
      "Filtros por marca, ano, KM e combustível",
      "Fotos, vídeos e link para financiamento",
      "3 impulsionamentos grátis por ciclo",
    ],
    cta: "Assinar Guia Auto", href: "/planos" },
];

// SEO segment landing pages
export const SEGMENTS = [
  { slug: "restaurantes-em-joao-pessoa", label: "Restaurantes", category: "onde-comer", href: "/empresas?category=onde-comer", image: IMAGES.food,
    title: "Restaurantes em João Pessoa", h1: "Os melhores restaurantes em João Pessoa",
    desc: "Descubra restaurantes em João Pessoa: frutos do mar em Tambaú, gastronomia em Cabo Branco, bares e cafés na orla e nos bairros nobres.",
    intro: ["De frutos do mar frescos na orla de Tambaú a bistrôs autorais em Manaíra e Cabo Branco, João Pessoa tem uma cena gastronômica vibrante. No Guia de Jampa AI você encontra onde comer com informações reais, endereço, WhatsApp e fotos.",
            "Filtre por bairro, veja empresas em destaque e pergunte à nossa Inteligência Artificial recomendações personalizadas para o seu momento — um jantar romântico, um almoço em família ou um happy hour."] },
  { slug: "hoteis-em-joao-pessoa", label: "Hotéis", category: "hoteis", href: "/empresas?category=hoteis", image: IMAGES.hotel,
    title: "Hotéis em João Pessoa", h1: "Hotéis e pousadas em João Pessoa",
    desc: "Encontre hotéis e pousadas em João Pessoa, muitos à beira-mar em Tambaú e Cabo Branco. Compare opções e fale direto pelo WhatsApp.",
    intro: ["Hospede-se pertinho do mar. João Pessoa oferece hotéis à beira-mar, pousadas charmosas e resorts com estrutura completa, do Bessa ao Cabo Branco.",
            "Veja as opções cadastradas, localize no mapa e use a IA para achar a hospedagem ideal conforme seu perfil e orçamento."] },
  { slug: "praias-de-joao-pessoa", label: "Praias", category: "praias", href: "/feed?category=praias", image: IMAGES.beach,
    title: "Praias de João Pessoa", h1: "As praias de João Pessoa",
    desc: "Tambaú, Cabo Branco, Bessa, Seixas e mais: conheça as praias de João Pessoa, o ponto mais oriental das Américas, e o que fazer em cada uma.",
    intro: ["João Pessoa é a cidade mais verde e uma das mais tranquilas do litoral nordestino. Suas praias de águas mornas e piscinas naturais encantam moradores e turistas.",
            "Descubra a orla, o Farol do Cabo Branco (ponto mais oriental das Américas) e acompanhe o que está acontecendo nas praias em tempo real."] },
  { slug: "eventos-em-joao-pessoa", label: "Eventos", category: "eventos", href: "/feed?category=eventos", image: IMAGES.event,
    title: "Eventos em João Pessoa", h1: "Eventos e agenda cultural em João Pessoa",
    desc: "Shows, festivais, São João, réveillon e agenda cultural de João Pessoa. Fique por dentro do que acontece na cidade.",
    intro: ["Da programação junina aos grandes shows na orla, João Pessoa tem eventos o ano inteiro. Acompanhe a agenda cultural sempre atualizada.",
            "Receba o que está bombando na cidade e pergunte à IA o que fazer no fim de semana."] },
  { slug: "turismo-em-joao-pessoa", label: "Turismo", category: "turismo", href: "/feed?category=turismo", image: IMAGES.turismo,
    title: "Turismo em João Pessoa", h1: "Turismo em João Pessoa",
    desc: "O que fazer em João Pessoa: pontos turísticos, passeios, Estação Cabo Branco, Centro Histórico, orla e roteiros para todos os perfis.",
    intro: ["Conheça o Farol do Cabo Branco, a Estação Cabo Branco, o Centro Histórico, o Hotel Globo e o Parque Solon de Lucena — cartões-postais da cidade.",
            "Monte seu roteiro com ajuda da Inteligência Artificial e descubra experiências além do óbvio."] },
  { slug: "empresas-em-joao-pessoa", label: "Empresas", category: "empresas", href: "/empresas", image: IMAGES.city,
    title: "Empresas em João Pessoa", h1: "Empresas e serviços em João Pessoa",
    desc: "Guia comercial de João Pessoa: encontre empresas, comércios e serviços locais com contato, endereço e localização no mapa.",
    intro: ["O Guia de Jampa AI reúne empresas e serviços de João Pessoa em um só lugar, com página profissional, mapa e contato direto.",
            "Busque por categoria e bairro, veja negócios em destaque e conecte-se com quem você precisa."] },
  { slug: "promocoes-em-joao-pessoa", label: "Promoções", category: "promocoes", href: "/feed?category=promocoes", image: IMAGES.city,
    title: "Promoções em João Pessoa", h1: "Promoções e ofertas em João Pessoa",
    desc: "Ofertas, descontos e promoções de empresas de João Pessoa. Economize e aproveite o melhor da cidade.",
    intro: ["Fique por dentro das promoções de restaurantes, lojas e serviços de João Pessoa, atualizadas continuamente.",
            "Ative as notificações do app e receba ofertas perto de você."] },
  { slug: "saude-em-joao-pessoa", label: "Saúde", category: "saude", href: "/empresas?category=saude", image: IMAGES.storefront,
    title: "Saúde em João Pessoa", h1: "Saúde e bem-estar em João Pessoa",
    desc: "Clínicas, hospitais, laboratórios e serviços de saúde em João Pessoa. Encontre e entre em contato facilmente.",
    intro: ["Encontre clínicas, hospitais, laboratórios e profissionais de saúde em João Pessoa com informações de contato e localização.",
            "Filtre por bairro e fale direto com o estabelecimento."] },
  { slug: "imoveis-em-joao-pessoa", label: "Imóveis", category: "imoveis", href: "/empresas?category=imoveis", image: IMAGES.city, comingSoon: true,
    title: "Imóveis em João Pessoa", h1: "Imóveis em João Pessoa",
    desc: "Apartamentos, casas e lançamentos em João Pessoa. Em breve no Guia de Jampa AI.",
    intro: ["Estamos preparando uma nova experiência de imóveis para João Pessoa."] },
  { slug: "empregos-em-joao-pessoa", label: "Empregos", category: "empregos", href: "/feed?category=empregos", image: IMAGES.storefront, comingSoon: true,
    title: "Empregos em João Pessoa", h1: "Vagas de emprego em João Pessoa",
    desc: "Vagas e oportunidades de trabalho em João Pessoa. Em breve no Guia de Jampa AI.",
    intro: ["Estamos preparando uma nova experiência de empregos para João Pessoa."] },
];

export const SEGMENT_SLUGS = SEGMENTS.map((s) => s.slug);

export const AI_EXAMPLES = [
  "Onde jantar hoje em Tambaú?",
  "O que fazer com crianças em João Pessoa?",
  "Quais praias visitar neste fim de semana?",
  "Onde encontrar um hotel próximo à orla?",
  "Quais eventos estão acontecendo hoje?",
  "Onde há promoções perto de mim?",
];

// Build a real app URL from search inputs
export function buildSearchUrl({ q = "", category = "", bairro = "" }) {
  const params = new URLSearchParams();
  if (q.trim()) params.set("q", q.trim());
  if (bairro.trim()) params.set("neighborhood", bairro.trim());
  const typeByCat = { saude: "doctor", imoveis: "real_estate", eventos: "news" };
  if (category && typeByCat[category]) params.set("type", typeByCat[category]);
  else if (category) { params.set("type", "business"); params.set("category", category); }
  const qs = params.toString();
  return `/busca${qs ? `?${qs}` : ""}`;
}

// Lightweight analytics (ready for GA/GTM via window.dataLayer)
export function track(event, data = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.debug("[track] failed:", e);
  }
  if (process.env.NODE_ENV !== "production") console.debug("[track]", event, data);
}
